<template>
  <v-dialog v-model="dialog" persistent max-width="980px">
    <template #activator="{on}">
      <v-btn color="accent" outlined v-on="on">
          <v-icon left>mdi-check</v-icon>
          {{ model.canPayout ? "Add Payout" : "Add Deposit" }}
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{
            order.canPayout ? "Add Payout" : "Add Deposit"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
            >{{ message }}</v-alert
          >
          <v-row>
            <v-col>
              <v-sheet class="pa-2" color="grey lighten-2">
                <v-row>
                  <v-col>{{ 'Order :' }}</v-col>
                  <v-col>{{ order.id }}</v-col>
                  <v-col>Amount remaining:</v-col>
                  <v-col>
                    {{ order.currency.currency }}
                    {{ order.amountRemaining }}
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :items="types"
                v-model="model.typeId"
                label="Type"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            v-if="model.typeId == 'card'"
          >
            <v-col>
              <customer-card
                v-model="model.cardId"
                label="Credit Card"
                :customerId="order.clientId"
              ></customer-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="model.amount"
                label="Amount"
                :rules="mandatoryRules"
                :prefix="order.currency.currency"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="model.comment"
                label="Comment"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel()"
            :disabled="loading"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="create()"
            :disabled="loading"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
    <ConfirmBox ref="confirm" />
  </v-dialog>
</template>

<script>
import CustomerCard from "@components/customer/CustomerCard.vue";
import ConfirmBox from "../ui/ConfirmBox.vue";
function getDefaultData() {
  return {
    dialog: false,
    model: {
      orderId: null,
      typeId: null,
      amount: null,
      comment: null,
      cardId: null,
    },
    mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
    loading: false,
    valid: false,
    message: null,
    creditAmount: 0,
  };
}
export default {
  components: {
    CustomerCard,
    ConfirmBox
},
  props: {
    order: {
      type: Object,
      required: true
    },
    invoices: {
      type: Array,
      required: true
    }

  },
  data: getDefaultData,
  computed: {
    types: function() {
      return [
        { text: "Cash", value: "cash" },
        { text: "Gift Card", value: "gift_card" },
        { text: "Virement", value: "virement" },
        {
          text:
            "Client's credit (" +
            this.creditAmount +
            " " +
            this.order.currency.currency +
            ")",
          value: "credit",
        },
        { text: "CyberSource", value: "cybersource" },
        { text: "TPE Xperience", value: "tpe_xperience" },
      ];
    },
  },
  mounted() {
    this.initialize()
  },
  watch: {
    dialog (v) {
      if(v){
        this.model.orderId = this.order.id;
        this.model.amount = this.order.amountRemaining;
      }
    }
  },
  methods: {
    initialize() {
      this.$store
        .dispatch("clients/getCredits", {
          currency: this.order.currency.currency,
          clientId: this.order.clientId,
        })
        .then((result) => (this.creditAmount = result));
    },
    async create() {
      if (this.$refs.form.validate()) {
        if (
            (this.model.amount > this.order.amountInvoiced && 
            await this.$refs.confirm.open("Are you sure ?", "Amount is greater than invoiced amount, the balance will be credited to the customer's account, are you sure ?"))
            || this.model.amount <= this.order.amountInvoiced
        ) {
          this.loading = true;

          this.$store
            .dispatch("orders/addPayout", {
              model: this.model,
            })
            .then((result) => {
              if (result.success) {
                this.$emit("payoutAdded");
                this.resetForm();
              } else {
                this.message = result.message;
              }
            })
            .catch(({ data }) => {
              this.message = data.message;
            })
            .finally(() => (this.loading = false));
        }
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
      this.initialize()
    },
  },
};
</script>

<style></style>
